import React from "react";
import { Table, Flex } from "antd";
import TimesCard from "./card";
import { getCurrentShop, getCurrentShopId } from "../../shop/get-current-shop";
import SwitchShop from "../../shop/switch-shop";

export default () => { 
    const [cardList, setCardList] = React.useState([]);
    const params = new URLSearchParams(window.location.search);
    const [shopId, setShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
            params.set("shopId", id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getCardList();
        }
    }, [shopId]);

    const getCardList = async () => {
        if (!shopId) return;
        
        const response = await fetch(`/api/promotion/goods-card-list?${params.toString()}`);
        return await response.json();
    }

    return (
        <div>
            <SwitchShop />
            
            <h2 className="admin-page-title">次卡售卖明细</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                {
                    cardList?.length && (
                        cardList.map((card, index) => (
                            <TimesCard key={card.cardId} content={card} />
                        ))
                    )
                }
            </div>
        </div>
    );
};